export enum FileIconType {
  Video = 'play',
  Img = 'image',
  Doc = 'pdf'
}
